import { render, staticRenderFns } from "./AIBuildModal.vue?vue&type=template&id=1480c3aa&"
import script from "./AIBuildModal.vue?vue&type=script&lang=ts&"
export * from "./AIBuildModal.vue?vue&type=script&lang=ts&"
import style0 from "./AIBuildModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports